import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { UpdateAttribute } from '@models/updateAttribute.model';
import { AutoCorrectionSettings, UpdateAutoCorrectionPayload } from '@models/auto-correction.model';
import { StorageService } from './storage.service';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class AttributeNewDeviceService extends HttpService {
  private apiUrl = `${environment.apiUrl}/devices`;

  updateAttributes(attributes: UpdateAttribute[]): Observable<any> {
    const options = this.createOptions();
    return this.post(`${this.apiUrl}/sensors/attributes/sync`, attributes, options);
  }

  getAutoCorrection(deviceId: string): Observable<AutoCorrectionSettings> {
    const options = this.createOptions();
    return this.get(`${this.apiUrl}/${deviceId}/auto-correction`, options);
  }

  updateAutoCorrection(deviceId: string, payload: UpdateAutoCorrectionPayload): Observable<AutoCorrectionSettings> {
    const options = this.createOptions();
    return this.patch(`${this.apiUrl}/${deviceId}/auto-correction`, payload, options);
  }

  private createOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.storageService.get('tok')}`
      })
    };
  }
}
